<template>
  <dg-field-container :field_mark="field_mark" :field_span="field_span" :field_textarea_rows="rows"
        :field_validate_message="validateMessage" :label_span="label_span">
    <template v-slot:label>
      <dg-label-field :label="label" :translate="translateLabel" v-if='label'></dg-label-field>
    </template>
    <template v-slot:field>
      <div v-if="editable">
        <el-input-number
          ref="number-input-el"
          v-model="field_value"
          @change="updateValue()"
          @blur="updateValue()"
          @input="liveUpdate ? updateValue() : null"
          :class="inputClass"
          class="devegram-input-text-field"
         :placeholder="placeholder"
         :readonly="readonly"
         :size="fieldSize"
         :disabled="disabled"
         :controls-position="controlsPosition"
         :precision="precision"
         :step="step"
         :step-strictly="stepStrictly"
         :min="min"
         :max="max"></el-input-number>
        <slot name="field_note"></slot>
      </div>
      <div v-else>
        <dg-label-field :label="field_value" :translate="false"></dg-label-field>
      </div>
    </template>
  </dg-field-container>
</template>

<script>
import inputField from './../mixins/inputField';

export default {
  mixins: [inputField],
  props: {
    min: {
      required: false,
      default: -Infinity
    },
    max: {
      required: false,
      default: Infinity
    },
    step: {
      required: false,
      default: 1
    },
    stepStrictly: {
      required: false,
      default: false
    },
    precision: {
      required: false,
      default: null
    },
    controlsPosition: {
      required: false,
      default: ''
    },
    fieldSize: {
      required: false,
      default: 'small'
    },
    rows: {
      required: false,
      default: 2
    },
    showPassword: {
      required: false,
      default: false
    },
    htmlautocomplete: {
      required: false,
      default: 'on'
    },
    textarea_error_top_margin: {
      required: false,
      default: 20
    }
  },
  data() {
    return {
      field_value: null
    }
  },
  mounted() {
    if (this.liveUpdate && this.editable) {
      let el = this.$refs['number-input-el'].$el.getElementsByTagName('input')[0]
      el.addEventListener('keyup', (i) => {
        el.blur()
        el.focus()
      })
    }
  }
}
</script>
